import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function ZoneOverview() {
  const colorMap: Record<string, { bg: string; icon: string; badge: string; border: string }> = {
    accent: {
      bg: 'bg-accent-50',
      icon: 'bg-accent-500',
      badge: 'bg-accent-100 text-accent-700',
      border: 'border-accent-200',
    },
    primary: {
      bg: 'bg-primary-50',
      icon: 'bg-primary-500',
      badge: 'bg-primary-100 text-primary-700',
      border: 'border-primary-200',
    },
    secondary: {
      bg: 'bg-secondary-50',
      icon: 'bg-secondary-500',
      badge: 'bg-secondary-100 text-secondary-700',
      border: 'border-secondary-200',
    },
  };

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            三大分区概览
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            一区二区三区 · 全景了解
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            三个分区各有侧重，从基础入门到专业深度，形成完整的内容生态体系。选择适合您的分区，开启高效学习之旅。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.accent;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group rounded-2xl ${colors.bg} border ${colors.border} p-6 md:p-8 transition-all duration-300 hover:scale-[1.02] cursor-pointer`}
              >
                <div className={`w-12 h-12 ${colors.icon} rounded-xl flex items-center justify-center mb-5`}>
                  <i className="ri-stack-line text-background-50 text-xl"></i>
                </div>
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className={`inline-block ${colors.badge} px-3 py-1 rounded-full text-xs font-medium mb-4`}>
                  {cat.subtitle}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                  {cat.description}
                </p>
                <span className={`text-sm font-medium ${colors.badge.replace('bg-', 'text-').replace(' text-', ' ').split(' ')[0] || 'text-primary-600'} flex items-center gap-1 group-hover:gap-2 transition-all`}>
                  查看详情
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}